import React, { useState } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { bindActionCreators } from 'redux'
import type { PlaylistId } from 'types/playlist'
import type { State } from 'types/redux'
import type { Track, TrackId } from 'types/track'
import { addNestedTracksToMain } from '@disco/state-management/actions/NestingActions'
import { uploadFilesToMainTrack } from '@disco/state-management/actions/upload-actions'
import { getAllSelectedItems } from '@disco/state-management/selectors/selection'
import { getTrack } from '@disco/state-management/selectors/tracks'
import ShortlistTrack from 'components/shortlist/track'
import TrackDropWrapper from 'containers/TrackDropWrapper'
type Props = {
  index: number
  uid: string | null | undefined
  itemIndex: number
  sourcePlaylistId: PlaylistId | null | undefined
  sourceShortlistId: string
  trackId: TrackId
}

const ShortlistTrackItem = ({
  index,
  uid,
  itemIndex,
  sourcePlaylistId,
  sourceShortlistId,
  trackId,
}: Props) => {
  const dispatch = useDispatch()
  const [showTrackVersions, setShowTrackVersions] = useState<boolean>(false)
  const track: Track | null | undefined = useSelector((state: State) =>
    getTrack(state, {
      id: trackId,
    }),
  )
  const selectedItems = useSelector(getAllSelectedItems)

  if (!track) {
    return null
  }

  return (
    <TrackDropWrapper
      selectedItems={selectedItems}
      track={track}
      onDragHold={() => setShowTrackVersions(true)}
      {...bindActionCreators(
        {
          uploadFilesToMainTrack,
          addNestedTracksToMain,
        },
        dispatch,
      )}
    >
      <ShortlistTrack
        index={index}
        uid={uid}
        itemIndex={itemIndex}
        showTrackVersions={showTrackVersions}
        sourcePlaylistId={sourcePlaylistId}
        sourceShortlistId={sourceShortlistId}
        track={track}
        onShowTrackVersions={setShowTrackVersions}
      />
    </TrackDropWrapper>
  )
}

export default React.memo<Props>(ShortlistTrackItem)
